import { Component, OnInit, ViewChild } from '@angular/core';
import { PfsService } from 'src/app/services/pfs.service';
import { AuthService } from 'src/app/services/auth.service';
import { AgGridAngular } from 'ag-grid-angular';
import { GridApi, Column } from 'ag-grid-community';

@Component({
  selector: 'app-pfs-summary',
  templateUrl: './pfs-summary.component.html',
  styleUrls: ['./pfs-summary.component.css']
})
export class PfsSummaryComponent implements OnInit {
  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;

  private gridApi!: GridApi;
  private gridColumnApi!: Column;

  nav: number = 0;
  rowData: any[] = [];

  columnDefs = [
    { field: 'entity_id', rowGroup: true, hide: true },
    { field: 'name', headerName: 'Name', sortable: true, filter: true },
    { field: 'data_source', headerName: 'Data Source', sortable: true, filter: true },
    { field: 'type', headerName: 'Type', sortable: true, filter: true },
    {
      field: 'value',
      headerName: 'Value',
      sortable: true,
      filter: true,
      aggFunc: 'sum',
      valueFormatter: this.currencyFormatter
    },
    {
      field: 'updated_at',
      headerName: 'Updated At',
      sortable: true,
      filter: true,
      //valueFormatter: this.dateFormatter
    }
  ];

  defaultColDef = {
    resizable: true,
    flex: 1
  };

  gridOptions = {
    getRowHeight: () => 24
  };

  autoGroupColumnDef = {
    headerName: 'Entity ID',
    field: 'entity_id',
    cellRendererParams: {
      suppressCount: false
    }
  };

  constructor(private pfsService: PfsService, private authService: AuthService) { }

  ngOnInit(): void {
    this.authService.getToken().subscribe((token: any) => {
      this.pfsService.getHoldingsByClient(99, token).subscribe((data: any[]) => {
        if (data && data.length > 0) {
          this.nav = data.reduce((sum, item) => sum + (item.value || 0), 0);
          this.rowData = data;
        }
      });
    });
  }

  onGridReady(params: any): void {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  clearFilters(): void {
    if (this.gridApi) {
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();
    }
  }

  currencyFormatter(params: any): string {
    return `$${params.value.toLocaleString(undefined, { minimumFractionDigits: 2 })}`;
  }

  dateFormatter(params: any): string {
    return new Date(params.value).toLocaleString();
  }
}